import { useState, useEffect } from 'react';
import './Solutions.css';
import logoIcon from '../assets/logo-icon.png';
import { useScrollReveal } from '../hooks/useScrollReveal';

function Solutions() {
    const [ref, visible] = useScrollReveal(0.1);
    const [activeTab, setActiveTab] = useState('problems');
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const solutions = [
        {
            problem: {
                icon: 'fas fa-clipboard-list',
                title: 'Scattered Patient Data',
                description:
                    'Patient information spread across paper files, WhatsApp messages, and multiple spreadsheets',
            },
            solution: {
                icon: 'fas fa-user-injured',
                title: 'Patient Management',
                description:
                    'Centralized patient profiles with personal information and complete visit history. Access everything during consultations.',
            },
        },
        {
            problem: {
                icon: 'fas fa-calendar-times',
                title: 'Appointment Chaos',
                description: 'Missed appointments, double bookings, and scheduling conflicts due to manual tracking',
            },
            solution: {
                icon: 'fas fa-calendar-check',
                title: 'Appointment Management',
                description:
                    'Schedule and manage patient appointments with a clear calendar interface. Reduce conflicts and missed appointments.',
            },
        },
        {
            problem: {
                icon: 'fas fa-boxes',
                title: 'Inventory Blindspots',
                description: 'No visibility into stock levels, leading to overstocking or unexpected shortages',
            },
            solution: {
                icon: 'fas fa-box-open',
                title: 'Inventory Tracking',
                description:
                    'Track medical supplies and products, monitor stock levels in real-time. Prevent shortages and overstocking.',
            },
        },
        {
            problem: {
                icon: 'fas fa-receipt',
                title: 'Billing Errors',
                description: 'Manual invoicing and payment tracking result in mistakes and poor cash flow visibility',
            },
            solution: {
                icon: 'fas fa-file-invoice-dollar',
                title: 'Invoicing & Payments',
                description:
                    'Generate invoices for services, track payment status, and maintain clear financial records with minimal effort.',
            },
        },
    ];

    return (
        <section ref={ref} className={`solutions ${visible ? 'visible' : ''}`}>
            <div className="solutions-content">
                <h2 className="section-title">Transform your clinic operations</h2>
                <p className="section-subtitle">
                    From chaos to clarity — see how Lemadoo solves real clinic challenges
                </p>

                {/* Mobile Toggle */}
                {isMobile && (
                    <div className="mobile-toggle">
                        <button
                            className={`toggle-btn ${activeTab === 'problems' ? 'active' : ''}`}
                            onClick={() => setActiveTab('problems')}
                        >
                            Problems
                        </button>
                        <button
                            className={`toggle-btn ${activeTab === 'solutions' ? 'active' : ''}`}
                            onClick={() => setActiveTab('solutions')}
                        >
                            <img src={logoIcon} alt="Lemadoo" className="toggle-logo" />
                        </button>
                    </div>
                )}

                {/* Desktop View - Side by Side */}
                {!isMobile && (
                    <div className="solutions-grid desktop-grid">
                    {solutions.map((item, index) => (
                        <div key={index} className="solution-row">
                            {/* Problem */}
                            <div className="problem-side">
                                <div className="card-header">
                                    <div className="card-icon problem-icon">
                                        <i className={item.problem.icon}></i>
                                    </div>
                                    <h4>{item.problem.title}</h4>
                                </div>
                                <p>{item.problem.description}</p>
                            </div>

                            {/* Solution */}
                            <div className="solution-side">
                                <div className="card-header">
                                    <div className="card-icon solution-icon">
                                        <i className={item.solution.icon}></i>
                                    </div>
                                    <h4>{item.solution.title}</h4>
                                </div>
                                <p>{item.solution.description}</p>
                            </div>
                        </div>
                    ))}
                    </div>
                )}

                {/* Mobile View - Single Column */}
                {isMobile && (
                    <div className="solutions-grid mobile-grid">
                    {solutions.map((item, index) => (
                        <div key={index} className="mobile-card">
                            {activeTab === 'problems' ? (
                                <div className="problem-side">
                                    <div className="card-header">
                                        <div className="card-icon problem-icon">
                                            <i className={item.problem.icon}></i>
                                        </div>
                                        <h4>{item.problem.title}</h4>
                                    </div>
                                    <p>{item.problem.description}</p>
                                </div>
                            ) : (
                                <div className="solution-side">
                                    <div className="card-header">
                                        <div className="card-icon solution-icon">
                                            <i className={item.solution.icon}></i>
                                        </div>
                                        <h4>{item.solution.title}</h4>
                                    </div>
                                    <p>{item.solution.description}</p>
                                </div>
                            )}
                        </div>
                    ))}
                    </div>
                )}
            </div>
        </section>
    );
}

export default Solutions;
